/**
 * LoseScreen.tsx
 * Lose screen
 */

import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import styles from '../MatchmakingModal.module.scss';

import sad from './sad.webp';

export interface ILoseScreenProps {
  isFreePlay?: boolean;
  onFindNewOpponent: () => void;
  onRematch: () => void;
}

export const LoseScreen: FC<ILoseScreenProps> = ({
  isFreePlay = false,
  onFindNewOpponent,
  onRematch,
}) => {
  const { t } = useTranslation('matchmaking');

  return (
    <div className={cx(styles.screen, styles.loseScreen)}>
      <div className={cx(styles.centered, styles.resultScreen)}>
        <div className={styles.resultIcon}>
          <span className={styles.emoji}>
            <img
              alt={t('alt.sadEmoji')}
              className={styles.sadImage}
              src={sad}
            />
          </span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {t('result.lose.subtitle')}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast" size="l">
          {t('result.lose.title')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          {isFreePlay ? (
            <Button
              className={styles.actionButton}
              color="accent"
              name={t('result.playAgain')}
              onClick={onFindNewOpponent}
              size="s"
              variant="filled"
            >
              {t('result.playAgain')}
            </Button>
          ) : (
            <>
              <Button
                className={styles.actionButton}
                color="accent"
                name={t('result.findNewOpponent')}
                onClick={onFindNewOpponent}
                size="s"
                variant="filled"
              >
                {t('result.findNewOpponent')}
              </Button>
              <Button
                className={styles.actionButton}
                color="primary"
                name={t('result.rematch')}
                onClick={onRematch}
                size="s"
                variant="filled"
              >
                {t('result.rematch')}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
